import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initErrorTracking } from './services/errorTracking';
import { ErrorBoundary } from './components/ErrorBoundary';
import { reportWebVitals } from './services/vitals';

// Initialize error tracking before React tree mounts
initErrorTracking();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);

// Report Core Web Vitals
reportWebVitals();
